if (!customElements.get('marquee-scroll')) {
customElements.define('marquee-scroll', class marqueeScroll extends HTMLElement {
  constructor() {
    super();
    this.scrolling = this.querySelector(".scrolling--item ");
    // Initialize near the viewport without relying on a missing theme-global helper.
    if ("IntersectionObserver" in window) {
      this.scrollInitObserver = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          this.scrollInitObserver.disconnect();
          this.initScroll();
        }
      }, { rootMargin: "300px 0px" });
      this.scrollInitObserver.observe(this);
    } else {
      this.initScroll();
    }
  }
  // Init Scolling
  initScroll() {
    // Some theme instances may render the custom element without its scrolling item.
    if (!this.scrolling) return;
    const childCount = this.childElementCount === 1 ? true : false;
    if (childCount) {
      this.scrolling.classList.add("scrolling--animated");

      for (let i = 0; i < 10; i++) {
        this.clone = this.scrolling.cloneNode(true);
        this.clone.setAttribute("aria-hidden", true);
        this.appendChild(this.clone);
      }
      
      // Pause off-screen animation where IntersectionObserver is supported.
      if ("IntersectionObserver" in window) {
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.classList.remove("scrolling--text--paused");
            } else {
              this.classList.add("scrolling--text--paused");
            }
          });
        }, { rootMargin: "0px 0px 50px 0px" });
        observer.observe(this);
      }
    }
  }
});  
}